import { Routes } from '@angular/router';
import { permissionGuard } from 'src/lib/guards/permission.guard';
import { roleGuard } from 'src/lib/guards/admin-role.guard';

export const statsRoutes: Routes = [
  {
    path: 'stats/status',
    data: { mode: 'SINGLE' },
    loadComponent: () =>
      import('./components/stats-status/stats-status.component').then(
        (m) => m.StatsStatusComponent,
      ),
    canActivate: [permissionGuard('BOOKING$STATISTICS')],
    children: [
      {
        path: 'list',
        data: { mode: 'SINGLE' },
        loadComponent: () =>
          import(
            './components/stats-status/monthly-summary/monthly-summary.component'
          ).then((m) => m.MonthlySummaryComponent),
      },
    ],
  },
  {
    path: 'stats/status-multiple',
    data: { mode: 'MULTIPLE' },
    loadComponent: () =>
      import('./components/stats-status/stats-status.component').then(
        (m) => m.StatsStatusComponent,
      ),
    canActivate: [permissionGuard('BOOKING$STATISTICS')],
    children: [
      {
        path: 'list',
        data: { mode: 'MULTIPLE' },
        loadComponent: () =>
          import(
            './components/stats-status/monthly-summary/monthly-summary.component'
          ).then((m) => m.MonthlySummaryComponent),
      },
    ],
  },
  {
    path: 'stats/calendar',
    data: { mode: 'MONTHLY' },
    loadComponent: () =>
      import(
        './components/stats-booking-calendar/stats-booking-calendar.component'
      ).then((m) => m.StatsBookingCalendarComponent),
    canActivate: [permissionGuard('BOOKING$STATISTICS')],
    children: [
      {
        path: 'list',
        loadComponent: () =>
          import(
            './components/stats-booking-calendar/stats-booking-calendar-detail/stats-booking-calendar-detail.component'
          ).then((m) => m.StatsBookingCalendarDetailComponent),
      },
    ],
  },
  {
    path: 'stats/calendar-annual',
    data: { mode: 'ANNUAL' },
    loadComponent: () =>
      import(
        './components/stats-booking-calendar/stats-booking-calendar.component'
      ).then((m) => m.StatsBookingCalendarComponent),
    canActivate: [
      roleGuard('ADMIN_SYSTEM'),
      permissionGuard('BOOKING$STATISTICS'),
    ],
    children: [
      {
        path: 'list',
        loadComponent: () =>
          import(
            './components/stats-booking-calendar-annual/stats-booking-calendar-annual-detail/stats-booking-calendar-annual-detail.component'
          ).then((m) => m.StatsBookingCalendarAnnualDetailComponent),
      },
    ],
  },
  {
    path: 'stats/sold-out-calendar',
    data: { mode: 'SOLD_OUT' },
    loadComponent: () =>
      import(
        './components/stats-booking-calendar/stats-booking-calendar.component'
      ).then((m) => m.StatsBookingCalendarComponent),
    canActivate: [
      permissionGuard('BOOKING$STATISTICS'),
      roleGuard('ADMIN_SYSTEM'),
    ],
    children: [
      {
        path: 'list',
        loadComponent: () =>
          import(
            './components/stats-booking-calendar/stats-booking-sold-out-detail/stats-booking-sold-out-detail.component'
          ).then((m) => m.StatsBookingSoldOutCalendarDetailComponent),
      },
    ],
  },
  {
    path: 'stats/item',
    loadComponent: () =>
      import('./components/stats-by-item/stats-by-item.component').then(
        (m) => m.StatsByItemComponent,
      ),
    canActivate: [permissionGuard('BOOKING$STATISTICS')],
    children: [
      {
        path: 'detail',
        loadComponent: () =>
          import(
            './components/stats-by-item/stats-by-item-detail/stats-by-item-detail.component'
          ).then((m) => m.StatsByItemDetailComponent),
      },
    ],
  },
  {
    path: 'stats/flights',
    loadComponent: () =>
      import('./components/stats-by-flights/stats-by-flights.component').then(
        (m) => m.StatsByFlightsComponent,
      ),
    canActivate: [permissionGuard('BOOKING$STATISTICS')],
    children: [
      {
        path: 'list',
        loadComponent: () =>
          import(
            './components/stats-by-flights/stats-by-item-flights-list/stats-by-item-flights-list.component'
          ).then((m) => m.StatsByItemFlightsListComponent),
      },
    ],
  },
  {
    path: 'stats/calc',
    loadComponent: () =>
      import('./components/stats-calc/stats-calc.component').then(
        (m) => m.StatsCalcComponent,
      ),
    canActivate: [permissionGuard('BOOKING$STATISTICS')],
  },
];
